<div class="header-helper">ID Verification</div>
<div *ngIf="!idVerified" class="content content-with-elevation">
    <p>Identity Verification is required to enable the Two-factor authentication (2FA) and API token features.</p>
    <p>You will need a government-issued photo ID and a device with a camera to complete the verification process.</p>
    <div class="grid-x align-end">
        <button class="iana-button" (click)="openIdConfirmation()">
            Begin ID Verification
        </button>
    </div>
</div>

<div *ngIf="idVerified" class="content content-with-elevation">
    <p *ngIf="!mfaEnabled">Identity Verification has been completed. Two-factor authentication can now be enabled.</p>
    <p *ngIf="mfaEnabled">Identity Verification has been completed.</p>
    <div class="grid-x align-end">
        <button class="iana-button" (click)="openIdConfirmation()">
            Update Verification
        </button>
    </div>
</div>

<common-smart-modal [dynamicID]="modalID"
                    [content]="modalContent"
                    [closeButtonText]="'Cancel'"
                    [acceptButtonText]="'Proceed'"
                    [contentHeader]="modalHeader"
                    [commentMode]="false"
                    (proceed)="confirmIdVerification()">
</common-smart-modal>
